import { gql } from "@apollo/client";

export const CREATE_SHIPMENT = gql`
  mutation CREATE_SHIPMENT(
    $customerId: ID!
    $invoiceInput: ShipmentInvoiceFromOdooInputType!
  ) {
    createShipment(customerId: $customerId, invoiceInput: $invoiceInput) {
      shipment {
        id
      }
    }
  }
`;
